import { Component } from '@angular/core';
import { spotSocket, adminBotUpsideHanumanSocket } from 'src/app/app.module';
import { Title } from '@angular/platform-browser';

// Import lib
import isEmpty from 'src/app/lib/isEmpty';
import { convert, fraction, longDecimals, nFormatter, toFixedDown, truncateDecimals } from 'src/app/lib/roundOf';
import { ShareService } from 'src/app/services/share.service';

// Import service
import { adminHanumanUpsideService } from 'src/app/services/bot.adminHanumanUpSIde.service';
import { TitleService } from 'src/app/services/title.service';

// Import facade
import { MarketPriceFacade } from 'src/app/store/marketprice';
import { TradePairFacade } from 'src/app/store/tradepair';

@Component({
  selector: 'app-hanumanUpsideOrderbook',
  templateUrl: './orderbook.component.html',
  styleUrls: ['./orderbook.component.css']
})
export class HanumanUpsideOrderbookComponent {

  convert = convert
  longDecimals = longDecimals
  fraction = fraction
  nFormatter = nFormatter

  isDiv1Visible = true;
  isDiv2Visible = true;
  isAuth: boolean = false

  dynamicWidth = '50%'

  truncateDecimals = truncateDecimals
  toFixedDown = toFixedDown

  tradePair: any = {}
  marketData: any = {}

  buyOrder: any[] = []
  sellOrder: any[] = []

  maxSize: number = 0

  showDiv1() {
    this.isDiv1Visible = true;
    this.isDiv2Visible = false;
  }

  showDiv2() {
    this.isDiv2Visible = true;
    this.isDiv1Visible = false;
  }

  showDivs() {
    this.isDiv1Visible = true;
    this.isDiv2Visible = true;
  }

  constructor(
    private adminHanumanUpsideService: adminHanumanUpsideService,
    private tradePairFacade: TradePairFacade,
    private marketPriceFacade: MarketPriceFacade,
    private spotSocket: spotSocket,
    private share: ShareService,
    private titleService: TitleService,
    private botSocket: adminBotUpsideHanumanSocket
  ) {
  }

  ngOnInit() {
    this.marketPriceFacade.marketPrice$.subscribe({
      next: (price: any) => {
        this.marketData = price
      },
      error: (err: any) => { }
    })

    this.tradePairFacade.tradePair$.subscribe({
      next: (pair: any) => {
        this.tradePair = pair
        if (!isEmpty(pair)) {
          let symbol = pair?.symbol ?? pair?.firstCurrencySymbol + pair?.secondCurrencySymbol
          this.fetchOrderBook(symbol)
          this.botSocket.on('orderBook', this.orderBookWs.bind(this))
          this.botSocket.on('marketPrice', this.marketPriceWs.bind(this))
        }
      },
      error: (err: any) => { }
    })
  }
  marketPriceWs(result: any) {
    let symbol = this.tradePair?.symbol ?? this.tradePair?.firstCurrencySymbol + this.tradePair?.secondCurrencySymbol
    if (result?.symbol == symbol) {
      this.marketData = result?.data
    }
  }
  getFillWidthStyle() {
    const fillWidth: number = 40;
    return { '--fillWidth': `40%` };
  }

  fetchOrderBook(pairId: string) {
    this.sellOrder = []
    this.buyOrder = []

    this.adminHanumanUpsideService.getOrderBook(pairId).subscribe({
      next: (v: any) => {
        if (v.success) {
          const maxAsking = Math.max(...v.result.buyOrder.map((o: any) => Number(o._id) * Number(o.quantity)));
          const maxBidding = Math.max(...v.result.sellOrder.map((o: any) => Number(o._id) * Number(o.quantity)));
          const max = Math.max(maxAsking, maxBidding);
          this.maxSize = Number(max);

          this.sellOrder = v.result && v.result.sellOrder
          this.buyOrder = v.result && v.result.buyOrder
        } else {
          this.sellOrder = []
          this.buyOrder = []
        }
      },
      error: (err: any) => { }
    })
  }

  orderBookWs(result: any) {
    let symbol = this.tradePair?.symbol ?? this.tradePair?.firstCurrencySymbol + this.tradePair?.secondCurrencySymbol
    if (result.symbol == symbol) {

      this.sellOrder = result && result?.data?.sellOrders
      this.buyOrder = result && result?.data?.buyOrders

      const maxAsking = Math.max(...result.buyOrders.map((o: any) => Number(o.price) * Number(o.quantity)));
      const maxBidding = Math.max(...result.sellOrders.map((o: any) => Number(o.price) * Number(o.quantity)));
      const max = Math.max(maxAsking, maxBidding);
      this.maxSize = Number(max);
    }
  }

  calculateBarWidth = (size: number) => {
    const percentage = (Number(size) / Number(this.maxSize)) * 100
    return `${percentage.toFixed(2)}%`;
  };

  handleClickOrder(price: string, quantity: string, type: string) {
    const payload = {
      price,
      quantity,
      type
    }
    this.share.headerClickSrc.next(payload);
  }


}
